import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 3.10367V8.07021C2 8.68033 2.49345 9.17388 3.10345 9.17388H8.06897C8.67897 9.17388 9.17241 8.68033 9.17241 8.07021C9.17241 7.46008 8.67897 6.96653 8.06897 6.96653H5.8831C6.91655 5.59729 8.5469 4.76677 10.2831 4.76677C13.3207 4.76677 15.7931 7.239 15.7931 10.2776C15.7931 13.3161 13.321 15.789 10.2828 15.789C9.08 15.789 7.9369 15.4086 6.97655 14.6874C6.48621 14.3242 5.79655 14.4201 5.43138 14.9073C5.06621 15.3957 5.16414 16.0875 5.65121 16.4528C6.99707 17.4626 8.59466 18 10.2788 18C14.5345 17.9998 18 14.5336 18 10.2776C18 6.02151 14.5345 2.55529 10.2793 2.55529C7.89483 2.55529 5.65862 3.67517 4.2069 5.52555V3.10367C4.2069 2.49355 3.71345 2 3.10345 2C2.49345 2 2 2.49355 2 3.10367Z",
		fill: "#0D2976"
	})
});
export default SvgUndo;
